module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門1_7_3.ce404f6a.png";